import {STATUS_SETS} from './issue-types';
import {ISSUE_ATTRIBUTES_MAPPED_ITEM_TYPES} from './issue-attributes';

export const superPropsFieldsMapping = {
  HOSTED_BY: 'Hosted By'
};

export const screenType = {
  PANEL: 'Viewer',
  PROJECT: 'Project',
  OTHER: 'N/A'
};

export const assigneeType = {
  ME: 'Me',
  MY_COMPANY: 'My Company',
  MY_ROLE: 'My Role',
  USER: 'User',
  COMPANY: 'Company',
  ROLE: 'Role',
  UNASSIGNED: 'Unassigned',
  OTHER: 'Other'
};

export const attachmentTypes = {
  UPLOAD: 'Upload',
  LINK: 'Link to Document'
};

export const emptyField = 'N/A';

export const reportFormats = {
  CSV: 'CSV',
  PDF: 'PDF',
  BCF: 'BCF',
  BCF_V2: 'BCF_V2',
  XLSX: 'XLSX'
};

export const analyticsItemTypeByAttributesItemType = {
  [ISSUE_ATTRIBUTES_MAPPED_ITEM_TYPES.CONTAINER]: 'All Types',
  [ISSUE_ATTRIBUTES_MAPPED_ITEM_TYPES.TYPE]: 'Type',
  [ISSUE_ATTRIBUTES_MAPPED_ITEM_TYPES.SUBTYPE]: 'Sub-type'
};

export const statusSetsMap = {
  [STATUS_SETS.BASIC]: 'Basic',
  [STATUS_SETS.FIELD]: 'Field'
};
